import allSettings from "../data/accountSettingsData";

export default function yearMonthFormat(source) {
    let date

    if (typeof source === "object") {
        date = `${source.getFullYear()}-${source.getMonth() + 1}`;
    } else {
        // Handle Firefox-specific date parsing issue
        let formattedSource;
        const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'];
        
        // Parse date strings like "January 2025" more reliably
        const parts = source.split(' ');
        if (parts.length === 2) {
            const monthIndex = monthNames.indexOf(parts[0]);
            const year = parseInt(parts[1]);
            if (monthIndex !== -1 && !isNaN(year)) {
                formattedSource = new Date(year, monthIndex, 1);
            } else {
                formattedSource = new Date(`1 ${source}`);
            }
        } else {
            formattedSource = new Date(`1 ${source}`);
        }
        
        date = `${formattedSource.getFullYear()}-${formattedSource.getMonth() + 1}`;
    }

    return date
}